import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { getURLParameters } from './lib/utils';

import i18next from 'i18next';
import Backend from 'i18next-chained-backend';
import Locize from 'i18next-locize-backend'; // load from service
import XHR from 'i18next-xhr-backend'; // have a own xhr fallback

var lang = getURLParameters('lang')
if(lang === 'zh_CN'){
    lang = 'sc'
}else if(lang === 'zh_HK'){
    lang = 'tc'
}else if(lang === 'en'){
    lang = 'en'
}else{
    lang = 'tc'
}
i18next
    .use(Backend)
    .init({
        backend: {
            backends: [
                Locize,  // primary
                XHR      // fallback
            ],
            backendOptions: [{
                loadPath: '/bochkfxibs/locales/{{lng}}/translation.json', // xhr load path for my own fallback
                projectId: 'BOC',
            }],
        },
        lng: lang,
        fallbackLng: 'tc'
    }, () => { ReactDOM.render(<App/>, document.getElementById('root')); });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
